import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseComponent } from 'src/app/base/base.component';
import DatabaseType, { DataConnectorType, MySqlDataConnector, MySqlDataConnectorInfo } from 'src/app/domainObjects/dataConnector';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { Time, DatePipe } from '@angular/common';
import { Observable,BehaviorSubject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';

export class MySqlDataConnectorViewModel extends DataConnectorViewModel<MySqlDataConnectorInfo> {
  id: number;
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName?: string;
  password?: string;
  isIntegratedSecurity = false;
  portNumber?: number;
  driver?: string;
  sqlCommand: string;
  connectionTimeout?:number;
  beginDate?: Date;
  endDate?: Date;
  isConnectionValid = false;
  beginTime?: string;
  endTime?: string;
  timestampField?: string;
  sampleStart?: number=0;
  sampleEnd?: number=1000;
  tableName?: string;
  sqlCodeExtention?: string;
  isBuildConnectionValid = false;

  constructor(dabaseConnector?: MySqlDataConnectorInfo) {
    super();
    this.dataConnectorType = DataConnectorType.Database;
    this.databaseType=DatabaseType.MySql;
    this.portNumber = 3306;  // Ensure portNumber has a default value
    this.connectionTimeout=60;
    if (dabaseConnector) {
      this.beginDate=dabaseConnector.beginDateRange;
      this.endDate=dabaseConnector.endDateRange;
      this.databaseName=dabaseConnector.databaseName;
      this.databaseServer=dabaseConnector.databaseServer;
      this.userName=dabaseConnector.userName;
      this.password=dabaseConnector.password;
      this.sqlCommand=dabaseConnector.sqlCommand;
      this.connectionTimeout=dabaseConnector.connectionTimeOut?? 60;
      this.portNumber = dabaseConnector.portNumber ?? 3306; // Ensure value exists
      this.isIntegratedSecurity=dabaseConnector.isIntegratedSecurity;
      this.driver=dabaseConnector.driver;
      this.beginTime=dabaseConnector.beginTime;
      this.endTime=dabaseConnector.endTime;
      this.timestampField=dabaseConnector.timestampField;
      this.sampleStart=dabaseConnector.sampleStart;
      this.sampleEnd=dabaseConnector.sampleEnd;
      this.tableName=dabaseConnector.tableName;
      this.sqlCodeExtention=dabaseConnector.sqlCodeExtention;
    }
  }
  validate(): boolean {
    return false;
  }

  toDataConnector(): MySqlDataConnector  {
    return new MySqlDataConnector(this.id, this.databaseType, this.databaseServer, this.databaseName,this.sqlCommand,this.connectionTimeout,this.isIntegratedSecurity,this.dataSourceType, this.userName,this.password,this.beginDate,this.endDate,this.portNumber, this.driver,this.beginTime,this.endTime, this.timestampField, this.sampleStart, this.sampleEnd, this.tableName, this.sqlCodeExtention);
  }
}

export class DataConnectorTestConnectionRequest {
  dataConnectorType: DataConnectorType;
}
export class MySqlDataConnectorTestConnectionRequest extends DataConnectorTestConnectionRequest {
  databaseType: DatabaseType;
  databaseServer: string;
  databaseName: string;
  userName: string;
  password: string;
  sqlText: string;
  portNumber: number;
  tableName:string;
  sqlQuery:string;
}

export class DataConnectorTestConnectionResponse {
  connected: boolean;
  errorMessage?: string;
  warning?: string;
}
@Component({
    selector: 'app-mysql-data-connector',
    templateUrl: './mysql-data-connector.component.html',
    styleUrls: ['./mysql-data-connector.component.css'],
    standalone: false
})
export class MysqlDataConnectorComponent extends BaseComponent implements OnInit {

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;

  progressBehavior = new BehaviorSubject<boolean>(false);
  DatabaseType = DatabaseType;
  dbForm: FormGroup;
  formGroups: FormGroup[] = [];
  viewModel = new MySqlDataConnectorViewModel();

  control = new UntypedFormControl('');
  tablelists: string[] = null;
  tablelistsOptions: Observable<string[]>;
  datetimeField:any=null
 separatorControl:FormControl;
  constructor(
    public datepipe: DatePipe,
    private changeDet: ChangeDetectorRef, 
    private mapperService: ConfigService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    errorReportingService: ErrorReportingService,
    matDialog: MatDialog) {
    super(errorReportingService, matDialog);
  }

  ngOnInit(): void {
    this.dbForm = this.fb.group({
          databaseServer: ['', Validators.required],
          databaseName: ['', Validators.required],
          userName: ['', Validators.required],
          password: ['', Validators.required],
          portNumber: ['', Validators.required]
      });
  
        // Register the form
        this.registerFormGroup(this.dbForm);
    
    this.dataTransformConfigViewModel.mySqlDataConnectorViewModel = this.viewModel;   
  }
  
  private _filter(value: string): string[] {
    const filterValue = this._normalizeValue(value);
    return this.tablelists.filter(name => this._normalizeValue(name).includes(filterValue));
  }
  registerFormGroup(group: FormGroup): void {
    if (group) {
        this.formGroups.push(group);
    }
}
  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  ngOnChanges(changes: any) {
    this.viewModel = changes.ingestConfigViewModel?.currentValue.getMySqlConnector();
    if (!this.viewModel) {
      this.viewModel = new MySqlDataConnectorViewModel();
      this.ingestConfigViewModel.dataConnector = this.viewModel;
    } else {
    }
    if(this.viewModel.tableName.length>0)
     this.getDatetimeField(this.viewModel.tableName);
  }

  async testConnection(): Promise<void> {

    if (this.dbForm.valid) {
      const request = new MySqlDataConnectorTestConnectionRequest();
      request.databaseServer = this.viewModel.databaseServer;
      request.databaseType = this.viewModel.databaseType;
      request.userName = this.viewModel.userName;
      request.password = this.viewModel.password;
      request.databaseName = this.viewModel.databaseName;
      request.portNumber = this.viewModel.portNumber;
  
      try {
        this.viewModel.isConnectionValid = false;
        this.progressBehavior.next(true);
        const response = await this.mapperService.testMySqlConnectorConnection(request);
        const isConnected = response.connected === 'true';
      
      if (!isConnected) {
        //console.log("if error");
          this.displayError(response.message || 'Connection attempt failed', 'Connection attempt failed');
      } else {
          this.viewModel.isConnectionValid = true;
        // console.log("if sucess");
          this.snackBar.open(`DataConnector connection is working!`, 'Dismiss', {
              duration: 5000
          });
      }
       
        this.progressBehavior.next(false);
      } catch (err) {
        this.progressBehavior.next(false);
        this.displayError('Failed to test connection', 'Error', err);
      }
    }
    else
    {
      this.dbForm.markAllAsTouched();
      this.changeDet.detectChanges(); // Force UI update
      return;
    }
   
  }

async refreshTableList(): Promise<void> {
  this.viewModel.tableName='';
  this.viewModel.timestampField='';
  this.viewModel.beginDate=new Date();
  this.viewModel.beginTime='';
  this.viewModel.endDate=new Date();
  this.viewModel.endTime='';
  const request = new MySqlDataConnectorTestConnectionRequest();

  request.databaseServer = this.viewModel.databaseServer;
  request.databaseType = this.viewModel.databaseType;
  request.userName = this.viewModel.userName;
  request.password = this.viewModel.password;
  request.databaseName = this.viewModel.databaseName;
  request.portNumber = this.viewModel.portNumber;


  try {
    this.viewModel.isConnectionValid = false;
    this.progressBehavior.next(true);
    const response = await this.mapperService.getMySqlTableList(request);
    if (response.errorMessage) {
      this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning){
      this.displayError(response.warning, 'Connection attempt failed');
    } else {
      this.viewModel.isConnectionValid = true;
      this.snackBar.open(`DataConnector connection is working!`, 'Dismiss', {
        duration: 5000
      });
      //console.log(response);
      this.tablelists=JSON.parse(JSON.stringify(response)).map(table => table.name); 
      this.tablelistsOptions = this.control.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '')),
      );
      this.changeDet.detectChanges();
      //console.log(this.tablelists);
      
    }
    this.progressBehavior.next(false);
  } catch (err) {
    this.progressBehavior.next(false);
    this.displayError('Failed to test connection', 'Error', err);
  }
}

async getDatetimeField(tablename,isManualTrigger: boolean = false): Promise<void> {
  const request = new MySqlDataConnectorTestConnectionRequest();
      request.databaseServer = this.viewModel.databaseServer;
      request.databaseType = this.viewModel.databaseType;
      request.userName = this.viewModel.userName;
      request.password = this.viewModel.password;
      request.databaseName = this.viewModel.databaseName;
      request.portNumber = this.viewModel.portNumber;
      request.tableName= this.viewModel.tableName;

  try {
    this.viewModel.isConnectionValid = isManualTrigger;
    this.progressBehavior.next(true);
    const response = await this.mapperService.getMySqlDatetimeField(request,tablename);
    this.datetimeField = [];
    if (response.errorMessage) {
      this.displayError(response.errorMessage, 'Connection attempt failed');
    } else if (response.warning) {
      this.displayError(response.warning, 'Connection attempt failed');
    } else if (!Array.isArray(response) || response.length === 0) {
      // Check if response is not an array OR if it's an empty array
      this.snackBar.open('No Timestamp Fields found!', 'Dismiss', {
        duration: 5000
      });
    } else {
      // Success case when response is a non-empty array
      if(isManualTrigger===true)
        this.snackBar.open(`Timestamp Fields have been retrieved!`, 'Dismiss', {
          duration: 5000
        });
    
      this.datetimeField = response;
      this.changeDet.detectChanges();
    }
    this.progressBehavior.next(false);
  } catch (err) {
    this.progressBehavior.next(false);
    this.displayError('Failed to test connection', 'Error', err);
  }
}

  async BuildQuery(){
  try{

    
      // If table name is missing, show snackbar message and exit the function
      if (!this.viewModel.tableName) {
        this.snackBar.open(`Table name is missing.`, 'Dismiss', {
          duration: 5000
        });
        this.progressBehavior.next(false);
        return; // Exit the function early
      }
      
    this.progressBehavior.next(true);

    let sqlquery = `SELECT * FROM ${this.viewModel.tableName}`;
    let sqlquerycount = `SELECT COUNT(1) AS total_rows FROM ${this.viewModel.tableName}`;
    let hasWhereClause = false;
    if (this.viewModel.timestampField) {
      let date = new Date(this.viewModel.beginDate);
    let timeParts = this.parseTime(this.viewModel.beginTime); // Convert "12:00 AM" to { hours: 0, minutes: 0 }

    // Set hours and minutes
    date.setHours(timeParts.hours, timeParts.minutes, 0, 0);
   // Assign to a variable
    let startformattedDateTime = this.formatDate(date); 


    
    let dateEnd = new Date(this.viewModel.endDate);
    let timePartsEnd = this.parseTime(this.viewModel.endTime); // Convert "12:00 AM" to { hours: 0, minutes: 0 }

    // Set hours and minutes
    date.setHours(timePartsEnd.hours, timePartsEnd.minutes, 0, 0);
    // Assign to a variable
    let endformattedDateTime = this.formatDate(dateEnd); 

    //sqlquery="SELECT * FROM "+this.viewModel.tableName;
    //sqlquery=sqlquery+" WHERE "+this.viewModel.timestampField+" BETWEEN '"+this.datepipe.transform(this.viewModel.beginDate, 'yyyy-MM-dd HH:mm:ss')+"' AND '"+this.datepipe.transform(this.viewModel.endDate, 'yyyy-MM-dd HH:mm:ss')+"'";
    sqlquery+= " WHERE "+this.viewModel.timestampField+" BETWEEN '"+startformattedDateTime+"' AND '"+endformattedDateTime+"'";
    hasWhereClause = true
    sqlquerycount+= " WHERE "+this.viewModel.timestampField+" BETWEEN '"+startformattedDateTime+"' AND '"+endformattedDateTime+"'";
  
    }
    
  
    if (this.viewModel.sqlCodeExtention) {
      sqlquery += (hasWhereClause ? " AND " : " WHERE ") + this.viewModel.sqlCodeExtention;
    }
    sqlquery=sqlquery+" ORDER BY 1 LIMIT  "+this.viewModel.sampleEnd+" OFFSET  "+(this.viewModel.sampleStart)+";";
    this.viewModel.sqlCommand=sqlquery;
    this.progressBehavior.next(false);
    this.viewModel.isBuildConnectionValid = true;


 const request = new MySqlDataConnectorTestConnectionRequest();
 request.databaseServer = this.viewModel.databaseServer;
 request.databaseType = this.viewModel.databaseType;
 request.userName = this.viewModel.userName;
 request.password = this.viewModel.password;
 request.databaseName = this.viewModel.databaseName;
 request.portNumber = this.viewModel.portNumber;
  request.sqlQuery=sqlquerycount;
 
     this.viewModel.isConnectionValid = false;
     this.progressBehavior.next(true);
 
     const response = await this.mapperService.mySQLTableRowCount(request);
     if (response.errorMessage) {
         this.displayError(response.errorMessage, 'Connection attempt failed');
     } else if (response.warning) {
         this.displayError(response.warning, 'Connection attempt failed');
     } else {
         this.viewModel.isConnectionValid = true;
         if (response.isrecordsmorethan1million === 'true') {
           this.snackBar.open(`The current query will return more than 1,000,000 rows`, 'Dismiss', {
             duration: 5000
           });
         }
        
     }
 
     this.progressBehavior.next(false);
 
   } catch (err) {
     this.progressBehavior.next(false);
     this.viewModel.isBuildConnectionValid = false;
     this.displayError('Failed to build query', 'Error', err);
   }
}
parseTime(timeStr: string): { hours: number, minutes: number } {
  let timeRegex = /(\d+):(\d+) (AM|PM)/;
  let match = timeStr.match(timeRegex);

  if (!match) return { hours: 0, minutes: 0 }; // Default

  let hours = parseInt(match[1]);
  let minutes = parseInt(match[2]);
  let period = match[3];

  // Convert 12-hour format to 24-hour format
  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  return { hours, minutes };
}

// Format a Date object into yyyy-MM-dd HH:mm:ss
formatDate(date: Date): string {
  let yyyy = date.getFullYear();
  let MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  let dd = String(date.getDate()).padStart(2, '0');
  let HH = String(date.getHours()).padStart(2, '0');
  let mm = String(date.getMinutes()).padStart(2, '0');
  let ss = String(date.getSeconds()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
}

/*onDateChange(event: any): void {
  const now = new Date(); // Current date and time
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  
  // Set yesterday's time to 00:00:00
  yesterday.setHours(0, 0, 0, 0);
  
  // Set today's time to 23:59:59
  now.setHours(23, 59, 59, 999);

  // Set the beginDate and endDate in the viewModel
  this.viewModel.beginDate = yesterday;
  this.viewModel.endDate = now;
 this.viewModel.beginTime = "12:00 AM"; // 12:00 AM
 this.viewModel.endTime = "12:00 AM";  // Set 1:00 AM as default time
}*/
// Function to handle selection change
async onDateChange(selectedValue: string): Promise<void> {
  console.log('Selected Timestamp Field:', selectedValue);

  // Validate selected field to avoid SQL injection risks
  if (!selectedValue) {
    console.error("Invalid timestamp field selected.");
    return;
  }

  // Dynamically construct SQL query
 // const sqlQuery = `SELECT MAX([${selectedValue}]) AS MOST_RECENT_DTTIME FROM [WC_MedMgmt].[dbo].[t_Users]`;
  // Dynamically construct SQL query with database name

const sqlQuery = `SELECT MAX(\`${selectedValue}\`) AS MOST_RECENT_DTTIME FROM \`${this.viewModel.tableName}\``;

const request = new MySqlDataConnectorTestConnectionRequest();
request.databaseServer = this.viewModel.databaseServer;
request.databaseType = this.viewModel.databaseType;
request.userName = this.viewModel.userName;
request.password = this.viewModel.password;
request.databaseName = this.viewModel.databaseName;
request.portNumber = this.viewModel.portNumber;;
  request.sqlQuery = sqlQuery;

  // Start progress indicator
  this.viewModel.isConnectionValid = true;
  this.progressBehavior.next(true);

  try {
    const response = await this.mapperService.mySQLMostRecentDate(request);
    this.viewModel.beginDate = new Date(response.recentDate);
    const enddate = new Date(response.recentDate);
    enddate.setDate(enddate.getDate() + 1);
    this.viewModel.endDate = enddate;
   this.viewModel.beginTime = response.recentTime; 
   this.viewModel.endTime = response.recentTime;   // Set 1:00 AM as default time
   
  } catch (error) {
    console.error("Error while executing SQL query:", error);
    this.displayError("An unexpected error occurred", "Query Execution Failed");
  } finally {
    // Stop progress indicator
    this.progressBehavior.next(false);
  }
}

}

